import { createTheme } from '@mui/material';
import { red } from '@mui/material/colors';

const theme = createTheme({
  typography: {
    fontFamily: ['Mukta', 'sans-serif'].join(','),
    h3: { fontSize: 20 },
    h2: { fontSize: 28, fontWeight: 'bold' },
    p: { fontSize: 16, fontWeight: '400' },
    h1: { fontSize: 18, fontWeight: '600' },
    subtitle: { fontSize: 14, fontWeight: '500' },
  },
  palette: {
    primary: {
      main: '#0D1C6E',
    },
    secondary: {
      main: '#19857b',
    },
    info: {
      main: '#424345',
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
